import React, {useState, useRef} from 'react'
import axios from 'axios'
import {graphql} from 'gatsby'
import ReCAPTCHA from 'react-google-recaptcha'
import { useForm } from 'react-hook-form'
import './MobileCampaignForm.scss'
import FormSuccessBox from '../FormSuccessBox/FormSuccessBox'
import TicketSVG from './TicketSVG'

export default function({title, text, campaign}) {
	const { register, handleSubmit, formState: { errors }, setValue, setError } = useForm({
		mode: 'onSubmit',
		reValidate: 'onChange'
	})
	const [showPopup, setShowPopup] = useState(false)
	const [popupText, setPopupText] = useState('Takk for din tilbakemelding!')
	//const [isVerified, setIsVerified] = useState(false)
	//const recaptchaRef = useRef(null)

	const onSubmit = (data) => {
		try {
			axios({
				method: 'post',
				url: '/.netlify/functions/feedback',
				data: data
			})
				.then(response => {
					if(response.data.status === 'success') {
						setPopupText('Takk for din tilbakemelding!')
						setShowPopup(true)
						setValue('contactFirstName', '')
						setValue('contactLastName', '')
						setValue('email', '')
						setValue('message', '')
					}
					if(response.data.status === 'failed') {
						setPopupText('Beklager, det oppstod en feil. Vennligst prøv igjen senere.')
						setShowPopup(true)
					}
				})

		} catch (err) {
			console.log('error: ', err)
		}
	}

	return(
		<div className="MobileCampaignForm">
			<FormSuccessBox visible={showPopup} close={() => setShowPopup(false)} text={popupText} />
			<div className="Block-container size-default">
				<div className="content">
					<h1>{title}</h1>
					<p>{text}</p>
					{
						campaign &&
							<div className="campaign">
								<TicketSVG />
								<p className="campaign-text">{campaign}</p>
							</div>
						}
				</div>
				<div className="form">
					<form onSubmit={handleSubmit(onSubmit)} className="register-form">

						<div className="doubleFields">
							<div className={errors.contactFirstName ? 'field error' : 'field'}>
								{errors.contactFirstName && <p className="errorMessage">{errors.contactFirstName.message}</p>}
								<label htmlFor="contactFirstName">Fornavn</label>
								<input
									type="text"
									{...register('contactFirstName', {
										required: "Du må fylle inn fornavn",
										minLength: {
											value: 2,
											message: "Navnet du har skrevet inn er for kort"
										},
										pattern: {
											value: /^([^0-9]*)$/,
											message: "Du kan ikke bruke tall i navnet"
										}
									})}
									id="contactFirstName"
									autoComplete="given-name" />
							</div>

							<div className={errors.contactLastName ? 'field error' : 'field'}>
								{errors.contactLastName && <p className="errorMessage">{errors.contactLastName.message}</p>}
								<label htmlFor="contactLastName">Etternavn</label>
								<input
									type="text"
									{...register('contactLastName', {
										required: "Du må fylle inn etternavn",
										minLength: {
											value: 2,
											message: "Navnet du har skrevet inn er for kort"
										},
										pattern: {
											value: /^([^0-9]*)$/,
											message: "Du kan ikke bruke tall i etternavnet"
										}
									})}
									id="contactLastName"
									autoComplete="family-name" />
							</div>
						</div>

						<div className={errors.email ? 'field error' : 'field'}>
							{errors.email && <p className="errorMessage">{errors.email.message}</p>}
							<label htmlFor="email">Epost</label>
							<input
								type="email"
								{...register('email', {
									required: "Du må fylle inn eposten din",
									pattern: {
										value: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
										message: "Ugyldig epostadresse"
									}
								})}
								id="email"
								autoComplete="email" />
						</div>

						<div className="field">
							<label htmlFor='message'>Melding</label>
							<textarea
								{...register('message')}
								id='message'
								rows='5' />
						</div>

						<div className="submit">
							<button className="Button primary" type="submit"><span>Send</span></button>
						</div>

						</form>
				</div>
			</div>
		</div>
	)
}

export const query = graphql`
	fragment MobileCampaignForm on WpPage_Layout_block_Layout_MobileCampaignForm {
		fieldGroupName
		title
		text
		campaign
	}
`;